export default __webpack_public_path__ + "static/media/grafema_pilates_06.4fd2534f.jpg";